export const SET_LOGIN = "SET_LOGIN";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_ROLE = "SET_ROLE";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";

export const SET_BID_REQUESTS = "SET_BID_REQUESTS";
export const SET_OPEN_ORDERS = "SET_OPEN_ORDERS";
export const SET_PREVIOUS_ORDERS = "SET_PREVIOUS_ORDERS";

export const SET_ORDERS_IN_PROGRESS = "SET_ORDERS_IN_PROGRESS";
export const SET_DRIVERS = "SET_DRIVERS";

export const SET_LOCATIONS = "SET_LOCATIONS";

export const SET_LOADER = "SET_LOADER";

export const LOGOUT = "LOGOUT";

export const SET_CHAT_HISTORY = "SET_CHAT_HISTORY";

// Redux thunk
export const FETCH_PROFILE = "FETCH_PROFILE";
export const SET_SELLER_ORDER_TAKING_STATUS = "SET_SELLER_ORDER_TAKING_STATUS";
export const SET_BIDS_FOR_INACTIVE_SELLER = "SET_BIDS_FOR_INACTIVE_SELLER";